



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs'
import axios from '../common/api';


@Component({
    components: {
    },
})
export default class Index extends Vue {
    pickerOptions:any = {}
    schedules:any[] = []
    value:any = ''
    @Prop() order:any
    @Prop() workingDays:any

    @Watch('order.specid')
    onSpecIdChanged(){
        this.value = ''
    }

    created(){
        axios.get('/specschedules').then(res=>{
            this.schedules = res.data
        })
        let self = this
        this.pickerOptions ={
            disabledDate: (d)=>{
                let str = dayjs(d).format('YYYY-MM-DD')
                let res = false
                if(self.order.specid){
                    let sches = self.schedules.find(s=>s.specid === self.order.specid && s.date === str)
                    if(sches){
                        res = true
                    }
                }
                res = res || d < Date.now() + 86400 * 1000 * self.workingDays
                return res
            },
            cellClassName:(d)=>{
                let str = dayjs(d).format('YYYY-MM-DD')
                let res = ''
                if(Date.now()>d){
                    res = 'past-date'
                } else if( d < Date.now() + 86400 * 1000 * self.workingDays){
                    res = 'working-date'
                } else if(self.order.specid){
                    let sches = self.schedules.find(s=>s.specid === self.order.specid && s.date === str)
                    if(sches){
                        res = 'blocked-date'
                    }
                }
               
                return res
            }
        }
    }
    dateChange(val){
        this.$emit('change',val)
    }
}
